import React, { useState, useEffect } from 'react';

const styles = {
    loader: {
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#000000',
        zIndex: 50,
    }
};

const Cube = () => {
    const cubeStyles = `
        .cube {
            width: 100%;
            height: 100%;
            position: relative;
            transform-style: preserve-3d;
            animation: rotate 3s infinite cubic-bezier(0.68, -0.55, 0.265, 1.55);
        }
        
        .cube-face {
            position: absolute;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: ui-monospace, monospace;
            font-size: 2rem;
            text-align: center;
            color: white;
            background: #000000;
            border: 2px solid rgba(99, 102, 241, 0.4);
            backface-visibility: visible;
            transform-style: preserve-3d;
        }
        
        .front { transform: translateZ(3.5rem); }
        .back { transform: rotateY(180deg) translateZ(3.5rem); }
        .right { transform: rotateY(90deg) translateZ(3.5rem); }
        .left { transform: rotateY(-90deg) translateZ(3.5rem); }
        .top { transform: rotateX(90deg) translateZ(3.5rem); }
        .bottom { transform: rotateX(-90deg) translateZ(3.5rem); }
        
        .glow {
            position: absolute;
            inset: -50%;
            background: rgba(99, 102, 241, 0.3);
            filter: blur(2rem);
            animation: pulse 2s infinite ease-in-out;
            pointer-events: none;
        }
        
        @keyframes rotate {
            0% { transform: rotateX(0) rotateY(0); }
            33% { transform: rotateX(360deg) rotateY(0); }
            66% { transform: rotateX(360deg) rotateY(360deg); }
            100% { transform: rotateX(0) rotateY(0); }
        }
        
        @keyframes pulse {
            0%, 100% {
                opacity: 0.5;
                transform: scale(1);
            }
            50% {
                opacity: 1;
                transform: scale(1.2);
            }
        }
        
        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: translateY(10px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
        
        .animate-fade-in {
            animation: fadeIn 0.8s ease-out forwards;
        }
        
        .animation-delay-300 {
            animation-delay: 300ms;
        }

        @media (max-width: 640px) {
            .cube-face {
                font-size: 1.25rem;
            }
        }

        @media (min-width: 641px) and (max-width: 1024px) {
            .cube-face {
                font-size: 1.75rem;
            }
        }
    `;

    return (
        <>
            <style>{cubeStyles}</style>
            <div className="cube">
                <div className="cube-face front"><div className="w-full text-center">UX</div></div>
                <div className="cube-face back"><div className="w-full text-center">UI</div></div>
                <div className="cube-face right"><div className="w-full text-center">UX</div></div>
                <div className="cube-face left"><div className="w-full text-center">UI</div></div>
                <div className="cube-face top"><div className="w-full text-center">UI</div></div>
                <div className="cube-face bottom"><div className="w-full text-center">UX</div></div>
            </div>
            <div className="glow"></div>
        </>
    );
};

const LoadingAnimation = ({ onLoadingComplete }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [showText, setShowText] = useState(false);

    useEffect(() => {
        setTimeout(() => setShowText(true), 500);
        const timer = setTimeout(() => {
            setIsVisible(false);
            if (onLoadingComplete) onLoadingComplete();
        }, 3000);

        return () => clearTimeout(timer);
    }, [onLoadingComplete]);

    if (!isVisible) return null;

    return (
        <div style={styles.loader}>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 lg:gap-8 px-4 text-center">
                <div className="flex items-center gap-4 sm:gap-6 lg:gap-8 order-1">
                    <span className="text-white font-mono text-2xl sm:text-3xl lg:text-4xl tracking-wide animate-fade-in">
                        Pushpalatha
                    </span>
                    <span className="text-white/50 font-mono text-2xl sm:text-3xl lg:text-4xl animate-fade-in hidden sm:block">
                        /
                    </span>
                </div>

                <div className="w-20 h-20 sm:w-24 sm:h-24 relative order-2 my-4 sm:my-0">
                    <Cube />
                </div>

                <div className="flex items-center gap-4 sm:gap-6 lg:gap-8 order-3">
                    <span className="text-white/50 font-mono text-2xl sm:text-3xl lg:text-4xl animate-fade-in hidden sm:block">
                        /
                    </span>
                    <span className="text-white font-mono text-2xl sm:text-3xl lg:text-4xl tracking-wide animate-fade-in animation-delay-300">
                        Shenoy
                    </span>
                </div>
            </div>
        </div>
    );
};

export default LoadingAnimation;